module.exports = __webpack_public_path__ + "assets/img/cardbgc.e092a617.png";